import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const InfertilityPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Infertility</h1>
        <section className="mb-8">
          <p>Infertility affects many couples and can be caused by various factors. Our natural therapies focus on improving reproductive health, balancing hormones, and enhancing fertility through gentle, holistic approaches that address both physical and emotional aspects.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Hormonal imbalances</li>
            <li>Stress and anxiety</li>
            <li>Poor lifestyle habits</li>
            <li>Nutritional deficiencies</li>
            <li>Age-related factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Irregular menstrual cycles</li>
            <li>Hormonal fluctuations</li>
            <li>Difficulty conceiving</li>
            <li>Stress and anxiety</li>
            <li>Physical and emotional strain</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use fertility-enhancing herbs, stress management techniques, and lifestyle modifications to naturally improve reproductive health. Our approach focuses on balancing hormones, improving reproductive function, and supporting overall well-being through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural hormone balancing</li>
            <li>Improved reproductive health</li>
            <li>No harsh side effects</li>
            <li>Holistic wellness support</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain a balanced diet</li>
            <li>Regular exercise</li>
            <li>Stress management</li>
            <li>Avoid harmful habits</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How effective is herbal treatment for infertility?</strong>
            <p>A: Our natural approach has helped many couples improve their fertility and achieve successful pregnancies.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for both partners?</strong>
            <p>A: Yes, our treatments are gentle and suitable for both men and women.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long does treatment take?</strong>
            <p>A: Treatment duration varies, but many couples see improvement within 3-6 months.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Start your journey to parenthood—book your natural fertility consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default InfertilityPage; 